import { PendingRecordDTO, PendingRecordListDTO, PendingRecordUpdateDTO } from 'src/dto/record.dto'
import { GetPendingRecordListParams, RecordService } from 'src/services/api/record.service'

export class RecordController {
  private service: RecordService

  constructor() {
    this.service = new RecordService()
  }

  public async getPendingRecordList(
    farmId: string,
    params?: GetPendingRecordListParams
  ): Promise<PendingRecordListDTO> {
    const pageParams = await this.getTotalCountPendingRecord(farmId, params)
    const response = await this.service.getPendingRecords(farmId, params)

    return {
      totalPages: pageParams.totalPages,
      total: pageParams.Total,
      list: response.data
    }
  }

  public async updatePendingRecord(farmId: string, pendingRecordDto: PendingRecordUpdateDTO[]): Promise<void> {
    await this.service.updatePendingRecord(farmId, pendingRecordDto)
  }

  public async getTotalCountPendingRecord(
    farmId: string,
    params?: GetPendingRecordListParams
  ): Promise<{ totalPages: number; Total: number }> {
    return this.service.getTotalCountPendingRecord(farmId, params)
  }

  public async getRecordById(
    farmId: string,
    recordId: string,
    params?: { status?: 'Rejeitado' | 'Processado' | 'Pendente' }
  ): Promise<PendingRecordDTO[]> {
    const response = await this.service.getRecordById(farmId, recordId, params)
    return response.data
  }

  public async getRecordFromTableById(table: string, farmId: string, recordId: string): Promise<PendingRecordDTO> {
    const response = await this.service.getRecordFromTableById(table, farmId, recordId)
    return response.data
  }
}
